// import react from "react";
function About() {

    return (
        <>
            <div class="row">
                <div class="col-2">

                </div>
                <div class="col-sm">
                    <img src="mypic.png" alt="MyPic" width="300" height="300" />
                    <h1 class="m-4 text-left">About Me</h1>
                    <div class="m-4 text-left">Hello World! My name is Silviya. I started my career in Software Development after graduating with a B.E. in Electronics Engineering from Anna University, Chennai in 2020. In addition, I'm Pursuing, a masters in Information Technology from Rutgers University, specializing in Software Development and business analytics.</div>
                    <div class="m-4 text-left">My MSIT studies provided me with a deep understanding of advanced topics such as artificial intelligence and machine learning, which have been invaluable in analyzing and interpreting complex data sets. I also had the opportunity to work on real projects and case studies, which allowed me to apply theoretical concepts to practical situations.</div>
                    <div class="m-4 text-left">Throughout my experience in software development, I've had the privilege of working alongside senior developers, talented teams, and innovative startups that shaped my skillset and raised my standards for what expected of any software developer.</div>
                    <div class="m-4 text-left">I take great pleasure in coding things from scratch and enjoy the process of bringing new ideas to life. However, I never neglect the importance of keeping my code clean, maintainable, and easy to understand.</div>
                    <h1 class="m-4 text-left">My Skills</h1>
                    <div class="m-4 text-left">Through my studies, I've gained a solid understanding of computer science concepts. In addition I have dedicated a lot of my free time to learn modern web development concepts and general porgramming skills.</div>
                    <div class="m-4 text-left">As a self-motivated learner, I've explored a variety of online resources, including Udemy. First I started with The Web Development Bootcamp that gave me all the skills I need to start building websites from scratch. From there, I went on to complete the Modern React with Redux course that helped me master all the fundamental concepts behind React and Redux applications.</div>
                    <table class="table">

                        <tbody>
                            <tr>
                                <td>HTML5</td>
                                <td>CSS</td>
                                <td>Javascript</td>
                                <td>React</td>
                            </tr>
                            <tr>
                                <td>Redux</td>
                                <td>NodeJS</td>
                                <td>Gatsby</td>
                                <td>Git</td>
                            </tr>
                            <tr>
                                <td>Git & GitHub</td>
                                <td>VS Code</td>
                                <td>Jira</td>
                                <td>Postman</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div class="col-2">

                </div>
            </div>
        </>
    )
}

export default About;